import React, { useEffect } from 'react';
import EmptyTopNav from 'components/topNav/EmptyTopNav';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

const Error = ({ message = '' }: { message: string }) => {
    useEffect(() => {
        sessionStorage.clear();
    }, []);

    return (
        <div className="logout">
            <EmptyTopNav />

            <div className="u-margin-bottom">
                <Link to={'/login'} className={'c-link'}>
                    <FontAwesomeIcon icon={faChevronLeft} className={'c-icon c-icon--small'} /> Return to login
                </Link>
            </div>

            <div>
                <span> An unexpected error has occurred during login. If the issue persists please contact support. </span>
            </div>

            {message.length > 0 && (
                <div>
                    <span className="u-text-secondary"> Reason: {message} </span>
                </div>
            )}
        </div>
    );
};

export default Error;
